/** Every built-in part kind, registered once. Adding one is a file and a line here. */
import { registerKind } from '../registry';
import { prism, semicircle, slab } from './blocks';
import { lens } from './lens';
import { screen, stop } from './measure';
import { planeMirror, sphericalMirror } from './mirrors';
import { object, parallelBeam, pointSource, rayBox } from './sources';

let registered = false;

export function registerBuiltInKinds(): void {
    if (registered) return;
    registered = true;
    registerKind(object);
    registerKind(pointSource);
    registerKind(parallelBeam);
    registerKind(rayBox);
    registerKind(planeMirror);
    registerKind(sphericalMirror);
    registerKind(lens);
    registerKind(prism);
    registerKind(slab);
    registerKind(semicircle);
    registerKind(screen);
    registerKind(stop);
}

export * from './blocks';
export * from './lens';
export * from './measure';
export * from './mirrors';
export * from './sources';
